import * as React from 'react';
import { DataTable } from 'damco-components';
import { LoadingAnimation } from 'components/loading';
import { InPageDialog } from 'damco-components';
import { setSortForCBLTable } from '../../views/job-costing/utils/CostAndRevenueHelpers';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IStore } from 'reducers/index';
import { connect } from 'react-redux';
import { ISortModel } from 'reducers/filters/models';
import { resetSort, setPage, setSort } from 'actions/filters';
import { ISort } from 'views/job-costing/search/models';
import { fetchSalesOrderData } from 'actions/salesOrder';
import { salesOrdersCols } from 'constants/tableConstants';
import { sales_order_icon, status_text } from 'components/exception-management/constants';
import { formatDate, isFeatureEnabled } from 'utilities/util';
import { ModalMain } from 'damco-components';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import Tooltip from 'components/tooltip';
import { jobClose } from 'constants/customs';

interface IParams {
    targetId: number;
    isModalOpen: boolean;
    salesOrderResponse?: any;
    index: number;
    setCurrentIndex: (e: any) => void;
    onUpdate?: (id: any) => void;
    onAthenaRefresh?: (id: any) => void;
    onCancel?: (id: any) => void;
    onCreate?: (id: any) => void;
    onResend?: (id: any) => void;
    onSendCreateSalesOrder?: (id: any) => void;
    showCreate?: boolean;
    showUpdate?: boolean;
    showAthenaRefreshButton?: boolean;
    showCancel?: boolean;
    showResend?: boolean;
    showCreateSalesOrder?: boolean;
    number?: string;
    isResendMessageFeatureEnabled: boolean;
    hideSalesOrderNumber?: boolean;
}
interface IState{
    sorted: any[] | ISort[];
    clearFilters: boolean;
    isFetchinProgress: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    showDialog: boolean;
    errorMessage: string;
    refData: any[];
    errorDialogVisible: boolean;
}

interface IMapDispatchToProps {
    setSort: (sort: ISortModel) => void;
    setPage: (page: number) => void;
    resetSort: () => void;
    fetchSalesOrderData: (id: number, page?: number, pageSize?: number) => Promise<void>;
}
interface IMapStateToProps {
    responseData: any;
    isLoading: boolean;
    featureToggles: any;
}

interface IProperties extends IParams, IMapDispatchToProps, IMapStateToProps { }
export class _SalesOrders extends React.Component<IProperties, IState> {
    public myReason = React.createRef<any>();
    public state:IState = {
        clearFilters: false,
        showDialog: false,
        errorMessage: '',
        refData:[],
        isFetchinProgress: true,
        page: 1,
        pageSize: 10,
        totalCount: 0,
        sorted: [],
        errorDialogVisible: false
    }
    public selectTable:any = React.createRef();
    public refTable:any = React.createRef();
    public myTableWrap: any = null
    public componentDidMount = () =>{
        this.myTableWrap = document.querySelector('.SalesOrders')
        if (this.props.isModalOpen && this.props.salesOrderResponse && this.props.salesOrderResponse.data.length > 0) {
              this.fetchDataAndSaveinState(this.props.salesOrderResponse.data, this.props.salesOrderResponse.page, this.props.salesOrderResponse.pageSize, this.props.salesOrderResponse.pageCount)
        } else {
            this.props.fetchSalesOrderData(this.props.targetId, this.state.page, this.state.pageSize);
        }
    }
    public componentDidUpdate = (prevProps:any, prevState:any) => {
        if (!this.props.isModalOpen && prevProps.responseData !== this.props.responseData) {
            this.fetchDataAndSaveinState(this.props.responseData.data, this.props.responseData.page, this.props.responseData.pageSize, this.props.responseData.pageCount)
          }
        if (this.props.isModalOpen && prevProps.salesOrderResponse !== this.props.salesOrderResponse) {
            this.fetchDataAndSaveinState(this.props.salesOrderResponse.data, this.props.salesOrderResponse.page, this.props.salesOrderResponse.pageSize, this.props.salesOrderResponse.pageCount)
          }
        this.setSelected()
    }

    public openLinkAction = (item: any) => {
        const documentLink = ['FCR', 'HBL', 'HSWB'].includes(item.triggeredByDocumentType) ?
        `/job-costing/documents/${item.triggeredByDocumentId}` : `/job-costing/cbls/${item.triggeredByDocumentId}`;
        this.openInNewTab(documentLink)
      }
    
    public render(){
    const isSAPJobCloseNotification = isFeatureEnabled(FEATURE_TOGGLES.SAPJobCloseNotification, this.props.featureToggles);
    return(
        <div>
            <InPageDialog
                showDialog={this.state.showDialog}
                type={'error'}
                message={this.state.errorMessage}
                closeMethod={() => this.setState({showDialog: false, errorMessage: ''})} />
            {this.props.isLoading && <LoadingAnimation smallLoad={true} />}
            <div className="errorModal"><ModalMain 
                modal={this.state.errorDialogVisible} 
                title="Error Message"
                hideMethod={() => { this.setState({ errorDialogVisible: false, errorMessage: '' }) }}
                primaryMethod={() => { this.setState({ errorDialogVisible: false, errorMessage: '' }) }}
                btnTitle1={'OK'} >
                    <div>
                        {this.state.errorMessage.split('|').map((item, i) => 
                            <span key={i}>{item} <br /></span>
                        )}
                    </div>
            </ModalMain></div>
            <div id={this.props.isModalOpen ? 'receiving-fcrModal' : 'receiving-fcr'} ref={this.refTable}>
                <DataTable
                    data={this.state.refData}
                    columns={salesOrdersCols(isSAPJobCloseNotification, this.props.hideSalesOrderNumber)}
                    isSelectable={true}
                    selectedOption="single"
                    manualPagination={true}
                    isSortable={true}
                    isResizable={true}
                    hasFooter={true}
                    ref={this.selectTable}
                    showColumnOptions={false}
                    tableName={`SalesOrders`}
                    showPagination={this.props.responseData.data.length > 0}
                    pageCount={Math.ceil(this.state.totalCount / this.state.pageSize)}
                    fetchData={(state: any) => { this.tableOrderFetch(state) }}
                    expandable={false}
                />
            </div>
         </div>
    );}

    public fetchDataAndSaveinState  = (data: any, page: number, pageSize: number, totalCount: number) => {
        this.setState({
            isFetchinProgress: false,
            page,
            pageSize,
            refData: data,
            totalCount,
          }, () => {
            this.setData(this.state.refData, this.state.page, this.state.pageSize, this.state.totalCount)
          });
    }
   

    public openInNewTab = (url:string) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if
            (newWindow) {newWindow.opener = null
        }
      }
      
    public tableOrderFetch = (tableData: any) =>{
        let shouldFetch = true
        if(tableData && tableData.sorted.length > 0){
            const selectedCol = tableData.columns.filter((entry:any) => entry.accessor === tableData.sorted[0].id)
            if(selectedCol && selectedCol[0] && selectedCol[0].headerClassName.includes('no-sorting')){
                shouldFetch = false
            }
        }
        if(shouldFetch){
            this.props.setPage(tableData.page + 1)
            const samePageRequest = (tableData.page + 1 !== this.state.page || tableData.pageSize !== this.state.pageSize)  || tableData.sorted?.length > 0
            if (!this.state.isFetchinProgress && samePageRequest) {
              if (tableData) {
                this.setState({
                  page: tableData.page + 1,
                  pageSize: tableData.pageSize,
                  isFetchinProgress: true,
                  showDialog: false,
                }, () => {
                    if (tableData && tableData.sorted && tableData.sorted.length > 0 && tableData.sorted[0].id && tableData.sorted[0]!.id === 'messageDetails') {
                        this.setState({ isFetchinProgress: false });
                        return
                    }
                    if (tableData && tableData.sorted) {
                        this.setState({ sorted: tableData.sorted });
                        setSortForCBLTable(tableData.sorted, this.props.setSort);
                    } else if (this.state.sorted && this.state.sorted.length) {
                        setSortForCBLTable(this.state.sorted, this.props.setSort);
                    }
                    this.props.fetchSalesOrderData(this.props.targetId, this.state.page, this.state.pageSize);
                });
              }
            }
        }
    }

    public componentWillUnmount = () => {
        this.props.resetSort()
    }

    public setSelected = () => {
        setTimeout(() => {
            const htmlEl = this.getTableRows()
            if (htmlEl) {
                const currentEl = htmlEl[this.props.index];
                if (currentEl && currentEl.parentElement) {
                    currentEl.classList.add('-selected');
                    if (currentEl.querySelector('input')) {
                        currentEl.querySelector('input').checked = true
                    }
                }
            }
        }, 200)
    }
    public getTableRows = () => {
        if (!this.myTableWrap) {
          this.myTableWrap = document.querySelector('.SalesOrders')
        }
        if (this.myTableWrap) {
          const htmlEl = this.myTableWrap.querySelectorAll('.rt-tbody .rt-tr-group')
          if (htmlEl && htmlEl.length > 0) {
            const lgt = this.props.isModalOpen ? htmlEl.length > this.props.salesOrderResponse.length ? this.props.salesOrderResponse.length : htmlEl.length
            : htmlEl.length > this.props.responseData.length ? this.props.responseData.length : htmlEl.length
            for (let i = 0; i < lgt; i++) {
              if (htmlEl[i] && htmlEl[i].parentElement && i !== this.props.index) {
                htmlEl[i].classList.remove('-selected')
                if (htmlEl[i].querySelector('input') && !htmlEl[i].querySelector('input').hasAttribute('listenerOnClick')) {
                  htmlEl[i].querySelector('input').checked = false
                  htmlEl[i].querySelector('input').addEventListener('click', (e: any) => {
                    this.handleRadioSelection(e, i)
                  })
                  htmlEl[i].querySelector('input').setAttribute('listenerOnClick', 'true')
                }
              }
            }
          }
          return htmlEl
        }
      }
    public handleRadioSelection = (ev: any, index: number) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.props.setCurrentIndex) {
          this.props.setCurrentIndex(index)
        }
    }
    public openErrorModal = (message: any) => {
        this.setState({ errorMessage: message, errorDialogVisible: true })
    }

    private setData = (data: any, page: number, pageSize: number, totalCount: number) => {
        const getHmtl = (status: string, item: {}) => this.props.isModalOpen ? <span dangerouslySetInnerHTML={{ __html: `${status}` }} /> : 
        <><span dangerouslySetInnerHTML={{ __html: `${status}` }} />
        {!this.props.isModalOpen && <button className="link" onClick={() => this.openLinkAction(item)} dangerouslySetInnerHTML={{ __html:`${sales_order_icon.new}` }}/> }</>
        const getHmtlforJobCloseReopen = (status: string, item: {}) => 
        <><span dangerouslySetInnerHTML={{ __html: `${status}` }} />
        <Tooltip content={jobClose.REOPEN} id={'exportJob'}><button className="link" dangerouslySetInnerHTML={{ __html:`${sales_order_icon.jobClose}` }}/></Tooltip></>
        const getHmtlforJobClose = (status: string, item: {}) => 
        <><span dangerouslySetInnerHTML={{ __html: `${status}` }} />
        <Tooltip content={jobClose.CLOSE} id={'exportJob'}><button className="link" dangerouslySetInnerHTML={{ __html:`${sales_order_icon.jobClose}` }}/></Tooltip></>
        const getHmtlforError = (status: string, message: string) => <>
        <span dangerouslySetInnerHTML={{ __html: `${status_text.negative} ${status}` }} />
        {!this.props.isModalOpen && <button className="link" onClick={()=>this.openErrorModal(message)} dangerouslySetInnerHTML={{ __html:'View error' }}/> }
        </>
        if (data && data.length) {
            data = data.map((item: any) => {
                item.triggeredByDocumentNumberforCBL = item.triggeredByDocumentNumber
                item.triggeredByDocumentNumber = getHmtl(item.triggeredByDocumentNumber, item)
                if (item.rateErrorMessage && item.rateErrorMessage.trim() !== ''){
                    item.finOpsStatusNew = getHmtlforError(item.finOpsStatus, item.rateErrorMessage.toString())
                } else {
                    item.finOpsStatusNew = item.finOpsStatus
                }
                if(item.lastUpdatedDate) {
                    item.lastUpdatedDate = formatDate(item.lastUpdatedDate)
                }
                if(item.tentativeCloseDate) {
                    item.tentativeCloseDate = formatDate(item.tentativeCloseDate,'YYYY-MM-DD')
                }
                if(item.reopenDate) {
                    item.reopenDate = formatDate(item.reopenDate,'YYYY-MM-DD')
                }
                if(item.isClosed === 'REOPENED') {
                    item.isClosedForUI = getHmtlforJobCloseReopen(item.isClosed, item)
                } else if(item.isClosed === 'CLOSED') {
                    item.isClosedForUI = getHmtlforJobClose(item.isClosed, item)
                } else {
                    item.isClosedForUI = item.isClosed
                }
                return item;
            });
        }
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            refData: data
        })
    }
   
};
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    responseData: state.exportJob.salesOrderResponse,
    isLoading: state.exportJob.isFetchDataLoading,
    featureToggles: state.featureToggle.featureToggles,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    setPage: (page: number) => dispatch(setPage(page)),
    fetchSalesOrderData: (id: number, page?: number, pageSize?: number) => dispatch(fetchSalesOrderData(id, page, pageSize)),
});

export const SalesOrders = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SalesOrders);
